import React from 'react';
import './ActionBar.css';

const ActionBar = ({ 
  extraction,
  onShowHistory,
  onShowContext,
  onShowReprocess,
  isReprocessing,
  getStatusLabel,
  showSidebar,
  onNewExtraction
}) => {
  if (!extraction) return null;

  const isPending = extraction.status !== 'ocr_processed';

  return (
    <div className="action-bar-overlay">
      <div className="action-bar-left">
        {!showSidebar && (
          <button className="close-btn" onClick={onShowHistory}>
          ☰
        </button>
        )}
        <span className="extraction-id">ID: {extraction.id}</span>
        <span className={`extraction-status ${isPending ? 'pending' : ''}`}>
          Status: {getStatusLabel(extraction.status)}
          {isPending && (
            <span className="processing-indicator">
              <span className="spinner"></span>
              Processando...
            </span>
          )}
        </span>
      </div>
      <div className="action-bar-right">
        <button 
          className="btn btn-secondary"
          onClick={onShowContext}
        >
          Contexto
        </button>
        <button 
          className="btn btn-secondary"
          onClick={onShowReprocess}
          disabled={isReprocessing}
        >
          Reprocessar
        </button>
        <button className="new-extraction-btn" onClick={onNewExtraction}>
          Nova Extração
        </button>
      </div>
    </div>
  );
};

export default ActionBar;
